import { Component, computed } from '@angular/core';
import { FormBuilder, ReactiveFormsModule } from '@angular/forms';

import { BaseSummarySectionComponent } from '../../../../../../shared/base-classes/sections/base-summary-section.component';
import { SectionWrapperComponent } from '../../../../../../shared/components/containers/section-wrapper-container/section-wrapper-container.component';
import { VehicleInsurancesRecordModel } from '../../../models/vehicle-insurances-record.model';
import { ExpiresAtPillComponent } from 'app/shared/components/expires-at-pill/expires-at-pill.component';
import { VehicleLinkCardComponent } from '../../../../vehicles/components/vehicle-link-card/vehicle-link-card.component';
import { DateRangePillComponent } from 'app/shared/components/date-range-pill/date-range-pill.component';
import { SummaryItemComponent } from '../../../../../../../shared/components/summary-item/summary-item.component';
import {
	VEHICLE_INSURANCE_COVERAGE_TYPES,
	VEHICLE_INSURANCE_PREMIUM_PERIODS,
} from '../../../translations/vehicle-insurances-select-items';
import { GetTranslationKeyForValuePipe } from '../../../../../../shared/components/dropdowns/filter-multiselect-dropdown/get-translation-key-for-value.pipe';
import { TranslocoModule } from '@ngneat/transloco';

@Component({
	selector: 'app-vehicle-insurances-summary',
	templateUrl: 'vehicle-insurances-summary.component.html',
	imports: [
		ReactiveFormsModule,
		SectionWrapperComponent,
		ExpiresAtPillComponent,
		VehicleLinkCardComponent,
		DateRangePillComponent,
		SummaryItemComponent,
		GetTranslationKeyForValuePipe,
		TranslocoModule,
	],
})
export class VehicleInsurancesSummaryComponent extends BaseSummarySectionComponent<VehicleInsurancesRecordModel> {
	protected _skipCount: number = 0;
	coverageTypes = VEHICLE_INSURANCE_COVERAGE_TYPES;
	premiumPeriods = VEHICLE_INSURANCE_PREMIUM_PERIODS;

	constructor(private _formBuilder: FormBuilder) {
		super();
		this.detailsForm = this._formBuilder.group({
			tags: [null],
		});
	}

	isoDateFrom = computed(() =>
		new Date(this.recordData().startsAt).toISOString(),
	);
	isoDateTo = computed(() => new Date(this.recordData().endsAt).toISOString());

	protected _mapModelToForm(): void {
		const detailsFormData: any = {
			tags: this.recordData().tags,
		};
		this.detailsForm.setValue(detailsFormData);
	}

	protected _mapFormToModel(): Partial<VehicleInsurancesRecordModel> {
		return {
			tags: this.detailsForm.value.tags,
		};
	}
}
